import { render, staticRenderFns } from "./purchaseOrderModal.vue?vue&type=template&id=064831e1&scoped=true&"
import script from "./purchaseOrderModal.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderModal.vue?vue&type=style&index=0&id=064831e1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064831e1",
  null
  
)

export default component.exports